import { deviceListMsg, publishedMsg, t } from '../../common/i18n/index.js';
import { formatTimestampToDDMMYYYY } from '../../common/utils/dateUtils.js';
import { VirtualCatalogStatus } from '../../generated/api/models.js';
import { Anchor } from '../Anchor/Anchor.js';
import { CatalogProductsSummary } from '../CatalogProductsSummary/CatalogProductSummary.js';
import { DetailsWrapper } from '../DetailsWrapper/index.js';
import { Loading } from '../Loading/index.js';
import { CatalogInformationForStatus } from './CatalogInformation';
import { ViewDiscontinuedDevices } from './ViewDiscontinuedDevices';
import type { CommonError } from '../../common/types/errors.js';
import type { CatalogProduct } from '../../common/utils/catalogUtils.js';
import type { Catalog } from '../../generated/api/models.js';
import type { JSX } from 'react';

import './CatalogDetails.scss';

export interface CatalogPublishedDetailsProps {
  breadCrumbs: JSX.Element;
  publishedDate: number | undefined;
  billingAccount: string;
  catalog: Catalog;
  products: Record<string, Array<CatalogProduct>>;
  companyName: string;
  onClickBack: () => void;
  errors?: CommonError[];
  mdmId: string;
}

export const CatalogPublishedDetails = (props: CatalogPublishedDetailsProps) => {
  const { billingAccount, breadCrumbs, catalog, companyName, mdmId, onClickBack, products, publishedDate } = props;

  return (
    <DetailsWrapper
      detailsTop={breadCrumbs}
      id={`catalog-details-${catalog.catalogCode}`}
      classes={[`of-catalog-details`]}
      heading={catalog.name}
      headingBottom={companyName}
      headingTop={t.Z0HF(deviceListMsg)}
      heroPicto="billing-account"
    >
      <div className="ea-context-notification of-manage-catalog-draft">
        <div className="ea-context-notification__text">
          <div className="of-manage-catalog-draft__container">
            <div className="of-manage-catalog-draft__instructions">
              {t.JN25(publishedMsg)} {formatTimestampToDDMMYYYY(publishedDate)}
              <br />
              <span>
                <Anchor onClick={onClickBack}>{t.D1E9('Return')}</Anchor>
              </span>
            </div>
          </div>
        </div>
      </div>
      <CatalogInformationForStatus
        catalog={catalog}
        modificationStatus={VirtualCatalogStatus.ACTIVE}
        billingAccount={billingAccount}
        mdmId={mdmId}
      />
      <ViewDiscontinuedDevices discontinuedProducts={catalog.discontinuedProducts ?? []} />
      {!products || catalog.productCategories.some(value => !products[value]) ? (
        // load all category products first and then show product summary
        <Loading />
      ) : (
        <CatalogProductsSummary {...{ products }} />
      )}
    </DetailsWrapper>
  );
};
